// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nickname input: 452px width at 1536 screen = 29.43vw */
.nickname-textbox_textbox__3ssHX {
  width: 29.43vw;
  max-width: 452px;
  min-width: 180px;
  padding: 10px 16px;
  border: none;
  border-radius: 50px;
  border: 4px solid #FFAB00;
  background: transparent;
  color: #FFAB00;
  font-size: 18px;
}


.nickname-textbox_textbox__3ssHX:focus {
  outline: none;
  /* Removes default focus outline */
  box-shadow: 0 0 4px 1px #FFAB00;
  /* Optional: Focus glow effect */
}

.nickname-textbox_textbox__3ssHX::placeholder {
  color: #FEE5B1B2;
  opacity: 1;
  font-size: 16px;
}

@media (min-width: 769px) and (max-width: 1024px) {

  /* Tablet breakpoint */
  .nickname-textbox_textbox__3ssHX {
    width: 30vw;
    font-size: 16px;
  }

  .nickname-textbox_textbox__3ssHX::placeholder {
    font-size: 14px;
  }
}

@media (max-width: 768px) {

  /* Mobile breakpoint */
  .nickname-textbox_textbox__3ssHX {
    width: 50vw;
    font-size: 15px;
  }

  .nickname-textbox_textbox__3ssHX::placeholder {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Inputs/nickname-textbox.module.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,sBAAsB;EACtB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Nickname input: 452px width at 1536 screen = 29.43vw */\n.textbox {\n  width: 29.43vw;\n  max-width: 452px;\n  min-width: 180px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 50px;\n  border: 4px solid #FFAB00;\n  background: transparent;\n  color: #FFAB00;\n  font-size: 18px;\n}\n\n\n.textbox:focus {\n  outline: none;\n  /* Removes default focus outline */\n  box-shadow: 0 0 4px 1px #FFAB00;\n  /* Optional: Focus glow effect */\n}\n\n.textbox::placeholder {\n  color: #FEE5B1B2;\n  opacity: 1;\n  font-size: 16px;\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n\n  /* Tablet breakpoint */\n  .textbox {\n    width: 30vw;\n    font-size: 16px;\n  }\n\n  .textbox::placeholder {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* Mobile breakpoint */\n  .textbox {\n    width: 50vw;\n    font-size: 15px;\n  }\n\n  .textbox::placeholder {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textbox": `nickname-textbox_textbox__3ssHX`
};
export default ___CSS_LOADER_EXPORT___;
